import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  MenuItem,
  Modal,
  InputLabel,
  FormControl,
  Grid,
  Select,
  TextField,
  Button,
  Box,
  Paper,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseIcon from "@mui/icons-material/Close";
import SchoolIcon from "@mui/icons-material/School";
import SubjectIcon from "@mui/icons-material/Subject";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import TopicOutlinedIcon from "@mui/icons-material/TopicOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import UploadFileOutlinedIcon from "@mui/icons-material/UploadFileOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const AddMasterTopic = () => {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [classId, setClassId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [lessonId, setLessonId] = useState("");
  const [videoLink, setVideoLink] = useState("");
  const [topicName, setTopicName] = useState("");
  const [topicContent, setTopicContent] = useState("");
  const [pdfFile, setPdfFile] = useState(null);
  const [classData, setClassData] = useState([]);
  const [subjectData, setSubjectData] = useState([]);
  const [lessonData, setLessonData] = useState([]);
  let navigate = useNavigate();

  // Info dialog state
  const [infoOpen, setInfoOpen] = useState(false);

  const fetchClasses = async () => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Enquiry/ddlClassName`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({}),
      });
      if (!response.ok) {
        throw new Error(`Error fetching classes: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setClassData(data);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching classes.");
      setSnackbarMessage('An error occurred while fetching classes.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchSubjects = async (classId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Question/ddlSubject`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching subjects: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setSubjectData(data);
      } else {
        setSubjectData([]);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching subjects.");
       setSnackbarMessage('An error occurred while fetching subjects.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const fetchLessons = async (classId, subjectId) => {
    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const response = await fetch(`${apiUrl}/Question/ddlLession`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ classId, subjectId }),
      });
      if (!response.ok) {
        throw new Error(`Error fetching lessons: ${response.status}`);
      }
      const data = await response.json();
      if (data && Array.isArray(data)) {
        setLessonData(data);
      } else {
        setLessonData([]);
      }
    } catch (error) {
      console.error(error);
      // alert("An error occurred while fetching lessons.");
       setSnackbarMessage('An error occurred while fetching lessons.');
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleClassChange = (event) => {
    const selectedClassId = event.target.value;
    setClassId(selectedClassId);
    setSubjectId("");
    setLessonId("");
    setSubjectData([]);
    setLessonData([]);
    if (selectedClassId) {
      fetchSubjects(selectedClassId);
    }
  };

  const handleSubjectChange = (event) => {
    const selectedSubjectId = event.target.value;
    setSubjectId(selectedSubjectId);
    setLessonId("");
    setLessonData([]);
    if (selectedSubjectId && classId) {
      fetchLessons(classId, selectedSubjectId);
    }
  };

  const handleReset = () => {
    setClassId("");
    setSubjectId("");
    setLessonId("");
    setVideoLink("");
    setTopicName("");
    setTopicContent("");
    setPdfFile(null);
    setSubjectData([]);
    setLessonData([]);
  };

  const validateInputs = () => {
    if (!classId) {
      setErrorMessage("Please select a Class.");
      return false;
    }
    if (!subjectId) {
      setErrorMessage("Please select a Subject.");
      return false;
    }
    if (!lessonId) {
      setErrorMessage("Please select a Lesson.");
      return false;
    }
    if (!topicName.trim()) {
      setErrorMessage("Please enter a Topic Name.");
      return false;
    }
    if (!topicContent.trim()) {
      setErrorMessage("Please enter Topic Content.");
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validateInputs()) {
      setShowErrorModal(true);
      return;
    }

    try {
      const apiUrl = process.env.REACT_APP_BASE_URL;
      const token = sessionStorage.getItem("token");
      const formData = new FormData();
      formData.append("ClassId", classId);
      formData.append("SubjectId", subjectId);
      formData.append("TopicName", topicName);
      formData.append("LessionId", lessonId);
      formData.append("TopicContent", topicContent);
      formData.append("VideoLink", videoLink || "empty");
      if (pdfFile) {
        formData.append("PdfPath", pdfFile);
      }

      const response = await fetch(`${apiUrl}/OfflineTopicMaster`, {
        method: "POST",
        headers: {
          Authorization: token,
        },
        body: formData,
      });

      if (!response.ok) {
        // alert(`Error posting data: ${response.status}`);
         setSnackbarMessage(`Error posting data: ${response.status}`);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
      } else {
        setShowSuccessModal(true);
        handleReset();
      }
    } catch (error) {
      // alert(error);
       setSnackbarMessage(error);
      setOpenSnackbar(true);
      setSnackbarSeverity("error")
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  return (
    <div>
      <Container>
        {/* Header Box with Title + Info Button */}
        <Box
          sx={{
            backgroundColor: "#0B1F40",
            padding: "12px 24px",
            boxShadow: 3,
            borderRadius: "4px 4px 0 0",
            margin: "2px auto",
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="h4" sx={{ color: "#fff", fontWeight: "bold" }}>
            Add Topic
          </Typography>

          {/* ── Info Button ── */}
          <Tooltip title="About this page" arrow>
            <IconButton
              onClick={() => setInfoOpen(true)}
              size="small"
              sx={{
                color: "rgba(255,255,255,0.75)",
                border: "1.5px solid rgba(255,255,255,0.35)",
                borderRadius: "50%",
                width: 30,
                height: 30,
                ml: 0.5,
                transition: "all 0.2s ease",
                "&:hover": {
                  color: "#ffffff",
                  backgroundColor: "rgba(100,181,246,0.2)",
                  borderColor: "#64B5F6",
                  transform: "scale(1.1)",
                  boxShadow: "0 0 8px rgba(100,181,246,0.4)",
                },
              }}
            >
              <InfoOutlinedIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>

        <Paper
          elevation={3}
          style={{ padding: 16, width: "100%", margin: "auto", marginTop: 6 }}
        >
          <Grid container spacing={3} mt={1}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="classId">Class</InputLabel>
                <Select
                  value={classId}
                  onChange={handleClassChange}
                  label="Class"
                  id="classId"
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {classData.map((item) => (
                    <MenuItem key={item.classId} value={item.classId}>
                      {item.className}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="subjectId">Subject</InputLabel>
                <Select
                  value={subjectId}
                  onChange={handleSubjectChange}
                  label="Subject"
                  id="subjectId"
                  disabled={!classId}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {subjectData.map((item) => (
                    <MenuItem key={item.subjectId} value={item.subjectId}>
                      {item.subjectName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth required>
                <InputLabel htmlFor="lessonId">Lesson</InputLabel>
                <Select
                  value={lessonId}
                  onChange={(e) => setLessonId(e.target.value)}
                  label="Lesson"
                  id="lessonId"
                  disabled={!subjectId}
                >
                  <MenuItem value="">--Select--</MenuItem>
                  {lessonData.map((item) => (
                    <MenuItem key={item.lessionId} value={item.lessionId}>
                      {item.lessionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Video Link"
                value={videoLink}
                onChange={(e) => setVideoLink(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Topic Name"
                value={topicName}
                onChange={(e) => setTopicName(e.target.value)}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <TextField
                fullWidth
                label="Topic Content"
                value={topicContent}
                onChange={(e) => setTopicContent(e.target.value)}
                multiline
                rows={4}
                required
              />
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <Button variant="contained" component="label" startIcon={<Add />}>
                Upload PDF
                <input
                  type="file"
                  accept="application/pdf"
                  hidden
                  onChange={(e) => setPdfFile(e.target.files[0])}
                />
              </Button>
              {pdfFile && (
                <Typography variant="body2" sx={{ mt: 1 }}>
                  Selected: {pdfFile.name}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Box mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
                marginRight: "10px",
              }}
            >
              Save
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleReset}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
                marginRight: "10px",
              }}
            >
              Reset
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleCancel}
              style={{
                marginTop: "7px",
                width: "100px",
                height: "50px",
                padding: "10px 0",
                fontWeight: "bold",
              }}
            >
              Cancel
            </Button>
          </Box>
        </Paper>
      </Container>

      {/* Success Modal */}
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          <Box sx={{ backgroundColor: "#0B1F40", padding: "12px 16px" }}>
            <Typography
              id="success-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Topic Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              The Topic has been added successfully.
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      {/* Error Modal */}
      <Modal
        open={showErrorModal}
        onClose={() => setShowErrorModal(false)}
        aria-labelledby="error-modal-title"
        aria-describedby="error-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 24,
            overflow: "hidden",
          }}
        >
          <Box sx={{ backgroundColor: "#d32f2f", padding: "12px 16px" }}>
            <Typography
              id="error-modal-title"
              variant="h6"
              sx={{ color: "#fff" }}
            >
              Missing Required Field ⚠️
            </Typography>
          </Box>
          <Box sx={{ padding: "20px" }}>
            <Typography id="error-modal-description" sx={{ mb: 2 }}>
              {errorMessage}
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              <Button
                onClick={() => setShowErrorModal(false)}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* ── Info Dialog ── */}
      <Dialog
        open={infoOpen}
        onClose={() => setInfoOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "16px",
            boxShadow: "0 12px 40px rgba(11,31,61,0.2)",
            overflow: "hidden",
          },
        }}
      >
        {/* Header */}
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #0B1F3D 0%, #1565C0 100%)",
            color: "#ffffff",
            fontWeight: 700,
            fontSize: "1.2rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 3,
            py: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
            <InfoOutlinedIcon sx={{ fontSize: 22 }} />
            Add Topic — Page Guide
          </Box>
          
        </DialogTitle>

        <DialogContent sx={{ px: 3, py: 2.5 }}>

          {/* Purpose */}
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.7 }}>
            Use this form to create a new offline topic. A topic is a sub-unit within a lesson,
            linked to a specific class and subject. Fill in all required fields and optionally
            attach a video link or PDF before saving.
          </Typography>

          <Divider sx={{ mb: 2 }} />

          {/* Fields */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1.2, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Field Reference
          </Typography>

          <List dense disablePadding>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SchoolIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Class <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Select the class this topic belongs to. Changing the class resets and reloads both Subject and Lesson dropdowns."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SubjectIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Subject <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Enabled only after a Class is selected. Changing the subject resets and reloads the Lesson dropdown."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <MenuBookIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Lesson <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Enabled only after a Subject is selected. Lists lessons for the chosen class and subject combination."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <VideoLibraryOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Video Link</Typography>}
                secondary="Optional. Paste a URL to a video resource related to this topic. If left blank, it is submitted as 'empty'."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <TopicOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Topic Name <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Enter the name or title of the topic."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <ArticleOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Topic Content <span style={{ color: "red" }}>*</span></Typography>}
                secondary="Required. Enter the full body content or description for this topic. Supports multiple lines."
              />
            </ListItem>

            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.6 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <UploadFileOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Upload PDF</Typography>}
                secondary="Optional. Attach a PDF file for this topic. Only PDF format is accepted. The selected filename is shown below the button."
              />
            </ListItem>

          </List>

          <Divider sx={{ my: 2 }} />

          {/* Buttons */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Buttons
          </Typography>
          <List dense disablePadding>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <SaveOutlinedIcon sx={{ fontSize: 20, color: "#1976d2" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Save</Typography>}
                secondary="Validates all required fields and submits the topic. If validation fails a modal shows the specific missing field. On success a confirmation modal appears and the form resets."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <RestartAltIcon sx={{ fontSize: 20, color: "#d32f2f" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Reset</Typography>}
                secondary="Clears all fields and resets the cascading dropdowns without navigating away."
              />
            </ListItem>
            <ListItem alignItems="flex-start" sx={{ px: 0, py: 0.5 }}>
              <ListItemIcon sx={{ minWidth: 36, mt: 0.3 }}>
                <ArrowBackIcon sx={{ fontSize: 20, color: "#9c27b0" }} />
              </ListItemIcon>
              <ListItemText
                primary={<Typography variant="body2" fontWeight={600}>Cancel</Typography>}
                secondary="Navigates back to the previous page immediately without saving."
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Important notes */}
          <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, color: "#0B1F3D", letterSpacing: "0.4px", textTransform: "uppercase", fontSize: "0.75rem" }}>
            Important Notes
          </Typography>
          <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
            {[
              "Class → Subject → Lesson is a cascading chain; each depends on the previous selection.",
              "Subject is disabled until a Class is selected; Lesson is disabled until a Subject is selected.",
              "Changing Class clears and reloads both Subject and Lesson.",
              "Changing Subject clears and reloads Lesson only.",
              "All five required fields (Class, Subject, Lesson, Topic Name, Topic Content) must be filled before Save.",
              "Video Link and PDF are optional — the form can be saved without them.",
              "Only PDF files are accepted for upload.",
              "After a successful save the form resets automatically.",
            ].map((note, i) => (
              <Typography key={i} component="li" variant="body2" color="text.secondary" sx={{ mb: 0.5, lineHeight: 1.6 }}>
                {note}
              </Typography>
            ))}
          </Box>

        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#f5f5f5", px: 3, py: 2 }}>
          <Button
            onClick={() => setInfoOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#0B1F3D",
              color: "#fff",
              borderRadius: "8px",
              fontWeight: 600,
              "&:hover": { backgroundColor: "#1565C0" },
            }}
          >
            Got it
          </Button>
        </DialogActions>
      </Dialog>
      {/* ── End Info Dialog ── */}

    </div>
  );
};

export default AddMasterTopic;